<template>
  <form-group :name="name" :label="label" :help-text="helpText" :error="error">
    <color-widget
        :value="value"
        :nullable="nullable"
        :colors="colors"
        @input="$emit('input', $event)"
    ></color-widget>
  </form-group>
</template>

<script>
import FormGroup from "@/vendor/forms/FormGroups/Block/FormGroup";
import ColorWidget from "../Widgets/Color";

export default {
  components: {FormGroup, ColorWidget},

  props: {
    "name": {},
    "label": {},
    "helpText": {"default": null},
    "value": {},
    "error": {},
    "nullable": {},
    "colors": {}
  }
}
</script>
